<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :width="dialogWidth" :scrollable="true">
      <v-card>
        <v-card-title>Allgemeine Geschäftsbedingungen</v-card-title>
        <v-card-text>
          <aGBs :showHeader="false"/>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog()">
            <v-icon left>mdi-close-circle</v-icon>{{$t('common.close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import AGBs from "@/components/content/AGBs";

export default {
  name: "AGBDialog",
  components: {
    AGBs
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    closeAction: {
      type: Function,
      required: true
    },
  },
  data: function() {
    return {
      dialog: false,
    };
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "80%";
      }
      return "90%";
    },
  },
  watch: {
    visible: function(val) {
      this.dialog = val;
      if (val === true) {
        this.$ga.send({
          hitType: 'event',
          eventCategory: 'AGB',
          eventAction: 'show'
        });
      }
    },
    dialog: function(val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    closeDialog() {
      this.closeAction();
    },
  }
};
</script>
<style scoped>
</style>